<template>
  <div class="col-span-1 inline-flex h-full w-full flex-row items-center justify-between gap-3">
    <span class="mr-2 h-2/3">
      <slot name="icon"></slot>
    </span>
    <span class="flex-1">
      <slot name="label" class="text-center"></slot>
    </span>
  </div>
</template>
